"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVATAR_BADGE_BADGE_SIZES = void 0;
var _T_SHIRT_SIZES = require("./T_SHIRT_SIZES");
var AVATAR_BADGE_BADGE_SIZES = Object.freeze({
  md: _T_SHIRT_SIZES.T_SHIRT_SIZES.md,
  lg: _T_SHIRT_SIZES.T_SHIRT_SIZES.lg,
  xl: _T_SHIRT_SIZES.T_SHIRT_SIZES.xl,
  xxl: _T_SHIRT_SIZES.T_SHIRT_SIZES.xxl
});
exports.AVATAR_BADGE_BADGE_SIZES = AVATAR_BADGE_BADGE_SIZES;